import {Action} from 'redux'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

const initialCategoryState: ICategoryState = {
  data: {
    cardCategory: [],
    meta: {},
  },
  deleteSuccess: false,
  sortCardCategoryData: [],

  loading: false,
  success: false,
}

export interface ICategoryState {
  data: {
    cardCategory: any
    meta: {[key: string]: number}
  }
  activateSuccess?: boolean
  deactivateSuccess?: boolean
  singleActivateSuccess?: boolean
  singleDeactivateSuccess?: boolean
  deleteSuccess?: boolean
  sortCardCategoryData: ICategoryState[]
  loading?: boolean
  success?: boolean
}

export const reducer = (
  state: ICategoryState = initialCategoryState,
  action: ActionWithPayload<ICategoryState>
) => {
  switch (action.type) {
    case actionTypes.GET_ACTIVE_CARD_CATEGORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_ACTIVE_CARD_CATEGORY_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_ACTIVE_CARD_CATEGORY_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.GET_CARD_CATEGORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_CARD_CATEGORY_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_CARD_CATEGORY_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.ADD_CARD_CATEGORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.ADD_CARD_CATEGORY_SUCCESS: {
      return {
        ...state,
        data: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.ADD_CARD_CATEGORY_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.ADD_CARD_CATEGORY_RESET: {
      return {
        ...state,
        data: [],
        success: false,
      }
    }

    case actionTypes.UPDATE_CARD_CATEGORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.UPDATE_CARD_CATEGORY_SUCCESS: {
      return {
        ...state,
        success: true,
        loading: false,
      }
    }

    case actionTypes.UPDATE_CARD_CATEGORY_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.DELETE_CARD_CATEGORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.DELETE_CARD_CATEGORY_SUCCESS: {
      return {
        ...state,
        deleteSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DELETE_CARD_CATEGORY_FINISH: {
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
      }
    }

    case actionTypes.SINGLE_ACTIVATE_CARD_CATEGORY_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.SINGLE_ACTIVATE_CARD_CATEGORY_SUCCESS: {
      return {...state, activateSuccess: true, loading: false}
    }
    case actionTypes.SINGLE_ACTIVATE_CARD_CATEGORY_FINISH: {
      return {...state, activateSuccess: false, loading: false}
    }

    case actionTypes.SINGLE_DEACTIVATE_CARD_CATEGORY_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.SINGLE_DEACTIVATE_CARD_CATEGORY_SUCCESS: {
      return {...state, deactivateSuccess: true, loading: false}
    }

    case actionTypes.SINGLE_DEACTIVATE_CARD_CATEGORY_FINISH: {
      return {...state, deactivateSuccess: false, loading: false}
    }

    case actionTypes.SORT_CARD_CATEGORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.SORT_CARD_CATEGORY_SUCCESS: {
      return {
        ...state,
        sortCardCategoryData: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.SORT_CARD_CATEGORY_FINISH: {
      return {
        ...state,
        loading: false,
        success: false,
      }
    }

    case actionTypes.SORT_CARD_CATEGORY_RESET: {
      return {
        ...state,
        loading: false,
        success: false,
        sortCardCategoryData: [],
      }
    }

    default:
      return state
  }
}
